export const sortPromotions = (a, b) => {
  if (!a?.metadata?.sortOrder) return 1
  if (!b?.metadata?.sortOrder) return -1
  return a?.metadata?.sortOrder - b?.metadata?.sortOrder
}
